import { useMemo } from "react";
import { mergeStyleSets } from "@fluentui/merge-styles";

const classNames = {
  root: `Sync`,
  code: `SyncCode`,
  user: `SyncUser`,
  months: `SyncMonths`,
  button: `SyncButton`
};

export function useSyncStyles() {
  return useMemo(
    () => mergeStyleSets({
      root: [classNames.root, {}],
      code: [
        classNames.code,
        {
          width: `150px`
        }
      ],
      user: [
        classNames.user,
        {
          width: `250px`
        }
      ],
      months: [
        classNames.months,
        {
          width: `100px`
        }
      ],
      button: [
        classNames.button,
        {
          width: `32px`,
          minWidth: `auto`
        }
      ]
    }),
    []
  );
}
